import { fileNameMaximumLength } from '@shs-digi-care-monorepo/interfaces';

// Forbidden characters taken from https://docs.aws.amazon.com/AmazonS3/latest/userguide/object-keys.html#object-key-guidelines
// eslint-disable-next-line no-useless-escape
const FORBIDDEN_CHARS_PATTERN = /[\\{}^%`\]">[~<#|\/]/;

export interface FileNameValidationError {
    fileName: string;
    reason: string;
    params?: Record<string, unknown>;
}

export class FileNameValidationOperations {
    public static validateFileName(fileName: string): FileNameValidationError | null {
        if (fileName.length === 0) {
            return { fileName, reason: 'common.file-upload.empty-name' };
        }

        let decodedName: string;
        try {
            decodedName = decodeURIComponent(fileName);
        } catch {
            return { fileName, reason: 'common.file-upload.invalid-encoding' };
        }

        if (FORBIDDEN_CHARS_PATTERN.test(decodedName)) {
            return { fileName, reason: 'common.file-upload.forbidden-characters' };
        }

        if (decodedName.length > fileNameMaximumLength) {
            return {
                fileName,
                reason: 'common.fileUpload.exceeds-character-limit',
                params: { maxLength: fileNameMaximumLength }
            };
        }

        return null;
    }

    public static validateFiles(files: File[]): { valid: File[]; errors: FileNameValidationError[] } {
        const valid: File[] = [];
        const errors: FileNameValidationError[] = [];

        for (const file of files) {
            const error = FileNameValidationOperations.validateFileName(file.name);
            if (error) {
                errors.push(error);
            } else {
                valid.push(file);
            }
        }

        return { valid, errors };
    }
}
